import { HolderOutlined } from '@ant-design/icons'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { memo, useMemo } from 'react'

import cn from '../PrioritySortShared.module.scss'

export interface PrioritySortRowProps {
  index?: number
  name: string
  code: number
  isChanged: boolean
  isOverlay?: boolean
  dragProps?: object
  onClick?: () => void
  extra?: React.ReactNode
}

export const PrioritySortRow = memo(
  ({
    name,
    code,
    isChanged,
    isOverlay = false,
    dragProps = {},
    onClick,
    extra,
  }: PrioritySortRowProps) => (
    <div
      className={`${cn.sortableRow} ${isOverlay ? cn.overlayActive : ''} ${isChanged ? cn.changed : ''}`}
      onClick={onClick}
      {...dragProps}
    >
      <div className={cn.dragHandle}>
        <HolderOutlined />
      </div>
      <div className={cn.rowInfo}>
        <span className={cn.rowName}>{name}</span>
        <span className={cn.itemCode}>#{code}</span>
      </div>
      {extra && <div className={cn.rowExtra}>{extra}</div>}
    </div>
  )
)

export const SortablePriorityRow = memo(
  ({
    id,
    parentKey,
    ...props
  }: PrioritySortRowProps & { id: string; parentKey?: string }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id, data: { parentKey } })

    const style = useMemo(
      () => ({
        '--sortable-transform': CSS.Translate.toString(transform),
        '--sortable-transition': isDragging ? undefined : transition,
      }),
      [transform, transition, isDragging]
    )

    return (
      <div
        ref={setNodeRef}
        className={`${cn.sortableItem} ${isDragging ? cn.sortableItemDragging : ''}`}
        style={style}
      >
        <PrioritySortRow
          {...props}
          dragProps={{ ...attributes, ...listeners }}
        />
      </div>
    )
  }
)
